// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Dashboard Layout Styles */
.layout-container {
  display: flex;
  height: 100vh;
  background: #f8fafc;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Sidebar Styles */
.sidebar {
  width: 260px;
  min-width: 260px;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-right: 1px solid #334155;
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 100;
  overflow: hidden;
}

.sidebar.collapsed {
  width: 72px;
  min-width: 72px;
}

.sidebar-header {
  padding: 20px 16px;
  border-bottom: 1px solid #334155;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 80px;
}

.sidebar.collapsed .sidebar-header {
  padding: 20px 12px;
  justify-content: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
  flex: 1 1;
  min-width: 0;
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo-icon svg {
  width: 20px;
  height: 20px;
  color: white;
}

.logo-text {
  font-size: 16px;
  font-weight: 700;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-toggle {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-toggle:hover {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.3);
  color: #3b82f6;
}

.sidebar-toggle svg {
  width: 18px;
  height: 18px;
}

.sidebar.collapsed .sidebar-toggle {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.sidebar.collapsed .logo {
  display: none;
}

/* Navigation Styles */
.sidebar-nav {
  flex: 1 1;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: none;
  border: none;
  border-radius: 10px;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
}

.nav-item:hover {
  background: #334155;
  color: white;
}

.nav-item.active {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.nav-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.nav-icon svg {
  width: 100%;
  height: 100%;
}

.nav-label {
  white-space: nowrap;
}

.sidebar.collapsed .nav-label {
  display: none;
}

.sidebar.collapsed .nav-item {
  justify-content: center;
  padding: 12px;
}

/* Navigation Divider Styles */
.nav-divider {
  padding: 16px 16px 8px 16px;
  margin-top: 8px;
}

.nav-divider-label {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.nav-divider-line {
  height: 1px;
  background: #334155;
  margin: 8px 0;
}

.sidebar.collapsed .nav-divider {
  padding: 8px 0;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 16px;
  border-top: 1px solid #334155;
  position: relative;
}

.sidebar-user-menu-wrap {
  position: relative;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  background: #334155;
  width: 100%;
  border: none;
  text-align: left;
  color: inherit;
}

.user-info--clickable {
  cursor: pointer;
  transition: background 0.15s;
}

.user-info--clickable:hover {
  background: #3f4f63;
}

.user-info--active {
  background: #2563eb;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.sidebar-user-chevron {
  width: 16px;
  height: 16px;
  color: #94a3b8;
  flex-shrink: 0;
  transition: transform 0.15s;
}

.sidebar-user-chevron.open {
  transform: rotate(180deg);
}

.sidebar-user-dropdown {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  right: 0;
  background: #1e293b;
  border: 1px solid #475569;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  z-index: 120;
}

.sidebar-user-dropdown--collapsed {
  left: 0;
  right: auto;
  min-width: 200px;
}

.sidebar-user-dropdown-head {
  padding: 12px 14px;
  border-bottom: 1px solid #334155;
}

.sidebar-user-dropdown-head .user-name {
  font-size: 15px;
  font-weight: 600;
  color: #f8fafc;
}

.sidebar-user-dropdown-head .user-email {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-user-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 11px 14px;
  border: none;
  background: transparent;
  color: #e2e8f0;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
}

.sidebar-user-menu-item:hover {
  background: #334155;
}

.sidebar-user-menu-item svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.sidebar-user-menu-item--danger {
  color: #fca5a5;
  border-top: 1px solid #334155;
}

.sidebar-user-menu-item--danger:hover {
  background: rgba(239, 68, 68, 0.12);
}

.user-info.collapsed {
  justify-content: center;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 15px;
  flex-shrink: 0;
}

.user-details {
  flex: 1 1;
  min-width: 0;
}

.user-name {
  font-size: 15px;
  font-weight: 600;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-size: 15px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar.collapsed .user-details {
  display: none;
}

/* Main Content Styles */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* Header Styles */
.main-header {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.main-header--compact {
  padding: 12px 32px;
  justify-content: flex-end;
}

.main-header--compact .header-left {
  display: none;
}

.header-left {
  flex: 1 1;
}

.page-title {
  font-size: 1.375rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* User Menu Styles */
.user-menu-container {
  position: relative;
}

.user-menu-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: none;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.user-menu-trigger:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.user-avatar-small {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 15px;
}

.user-name-header {
  font-size: 15px;
  font-weight: 500;
  color: #374151;
}

.chevron {
  width: 16px;
  height: 16px;
  color: #6b7280;
  transition: transform 0.2s ease;
}

.chevron.open {
  transform: rotate(180deg);
}

.user-menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  min-width: 240px;
  z-index: 1000;
  animation: dropdownSlide 0.2s ease-out;
}

@keyframes dropdownSlide {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-menu-header {
  padding: 16px;
}

.user-info-dropdown .user-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.user-info-dropdown .user-email {
  font-size: 15px;
  color: #64748b;
  margin-bottom: 2px;
}

.user-info-dropdown .user-org {
  font-size: 15px;
  color: #94a3b8;
}

.user-menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0 8px;
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 15px;
  color: #374151;
  border-radius: 0 0 12px 12px;
}

.user-menu-item:hover {
  background: #f8fafc;
}

.user-menu-item svg {
  width: 16px;
  height: 16px;
  color: #6b7280;
}

/* Page Content Styles */
.page-content {
  flex: 1 1;
  padding: 24px 32px 16px;
  overflow-y: auto;
  background: #f8fafc;
  min-height: 0;
}

.app-footer {
  flex-shrink: 0;
  padding: 10px 32px 14px;
  text-align: center;
  font-size: 13px;
  color: #94a3b8;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  letter-spacing: 0.02em;
}

.app-footer-brand {
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.06em;
}

/* Sidebar Overlay for Mobile */
.sidebar-overlay {
  display: none;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 200;
    transform: translateX(-100%);
  }

  .sidebar:not(.collapsed) {
    transform: translateX(0);
  }

  .sidebar-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 150;
  }

  .main-content {
    margin-left: 0;
  }

  .main-header {
    padding: 16px 20px;
  }

  .page-content {
    padding: 20px;
  }
}

@media (max-width: 640px) {
  .main-header {
    padding: 12px 16px;
  }

  .page-title {
    font-size: 20px;
  }

  .user-name-header {
    display: none;
  }

  .page-content {
    padding: 16px;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .layout-container {
    background: #0f172a;
  }

  .main-header {
    background: #1e293b;
    border-bottom-color: #334155;
  }

  .page-title {
    color: #f8fafc;
  }

  .user-menu-trigger {
    border-color: #334155;
    background: #1e293b;
  }

  .user-menu-trigger:hover {
    background: #334155;
    border-color: #475569;
  }

  .user-name-header {
    color: #e2e8f0;
  }

  .user-menu-dropdown {
    background: #1e293b;
    border-color: #334155;
  }

  .user-info-dropdown .user-name {
    color: #f8fafc;
  }

  .user-info-dropdown .user-email {
    color: #94a3b8;
  }

  .user-menu-divider {
    background: #334155;
  }

  .user-menu-item {
    color: #e2e8f0;
  }

  .user-menu-item:hover {
    background: #334155;
  }

  .page-content {
    background: #0f172a;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uFAAuF;AACzF;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;EAC7D,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gGAAgG;EAChG,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Modern Dashboard Layout Styles */\n.layout-container {\n  display: flex;\n  height: 100vh;\n  background: #f8fafc;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* Sidebar Styles */\n.sidebar {\n  width: 260px;\n  min-width: 260px;\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  border-right: 1px solid #334155;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  z-index: 100;\n  overflow: hidden;\n}\n\n.sidebar.collapsed {\n  width: 72px;\n  min-width: 72px;\n}\n\n.sidebar-header {\n  padding: 20px 16px;\n  border-bottom: 1px solid #334155;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 80px;\n}\n\n.sidebar.collapsed .sidebar-header {\n  padding: 20px 12px;\n  justify-content: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow: hidden;\n  flex: 1;\n  min-width: 0;\n}\n\n.logo-icon {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.logo-icon svg {\n  width: 20px;\n  height: 20px;\n  color: white;\n}\n\n.logo-text {\n  font-size: 16px;\n  font-weight: 700;\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-toggle {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 10px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: rgba(59, 130, 246, 0.3);\n  color: #3b82f6;\n}\n\n.sidebar-toggle svg {\n  width: 18px;\n  height: 18px;\n}\n\n.sidebar.collapsed .sidebar-toggle {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.sidebar.collapsed .logo {\n  display: none;\n}\n\n/* Navigation Styles */\n.sidebar-nav {\n  flex: 1;\n  padding: 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  border-radius: 10px;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  width: 100%;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.nav-item:hover {\n  background: #334155;\n  color: white;\n}\n\n.nav-item.active {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.nav-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.nav-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.nav-label {\n  white-space: nowrap;\n}\n\n.sidebar.collapsed .nav-label {\n  display: none;\n}\n\n.sidebar.collapsed .nav-item {\n  justify-content: center;\n  padding: 12px;\n}\n\n/* Navigation Divider Styles */\n.nav-divider {\n  padding: 16px 16px 8px 16px;\n  margin-top: 8px;\n}\n\n.nav-divider-label {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n}\n\n.nav-divider-line {\n  height: 1px;\n  background: #334155;\n  margin: 8px 0;\n}\n\n.sidebar.collapsed .nav-divider {\n  padding: 8px 0;\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  padding: 16px;\n  border-top: 1px solid #334155;\n  position: relative;\n}\n\n.sidebar-user-menu-wrap {\n  position: relative;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 10px;\n  background: #334155;\n  width: 100%;\n  border: none;\n  text-align: left;\n  color: inherit;\n}\n\n.user-info--clickable {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.user-info--clickable:hover {\n  background: #3f4f63;\n}\n\n.user-info--active {\n  background: #2563eb;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);\n}\n\n.sidebar-user-chevron {\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n  flex-shrink: 0;\n  transition: transform 0.15s;\n}\n\n.sidebar-user-chevron.open {\n  transform: rotate(180deg);\n}\n\n.sidebar-user-dropdown {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  background: #1e293b;\n  border: 1px solid #475569;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  z-index: 120;\n}\n\n.sidebar-user-dropdown--collapsed {\n  left: 0;\n  right: auto;\n  min-width: 200px;\n}\n\n.sidebar-user-dropdown-head {\n  padding: 12px 14px;\n  border-bottom: 1px solid #334155;\n}\n\n.sidebar-user-dropdown-head .user-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #f8fafc;\n}\n\n.sidebar-user-dropdown-head .user-email {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sidebar-user-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 11px 14px;\n  border: none;\n  background: transparent;\n  color: #e2e8f0;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n}\n\n.sidebar-user-menu-item:hover {\n  background: #334155;\n}\n\n.sidebar-user-menu-item svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.sidebar-user-menu-item--danger {\n  color: #fca5a5;\n  border-top: 1px solid #334155;\n}\n\n.sidebar-user-menu-item--danger:hover {\n  background: rgba(239, 68, 68, 0.12);\n}\n\n.user-info.collapsed {\n  justify-content: center;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.user-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-role {\n  font-size: 15px;\n  color: #94a3b8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar.collapsed .user-details {\n  display: none;\n}\n\n/* Main Content Styles */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n/* Header Styles */\n.main-header {\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 20px 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.main-header--compact {\n  padding: 12px 32px;\n  justify-content: flex-end;\n}\n\n.main-header--compact .header-left {\n  display: none;\n}\n\n.header-left {\n  flex: 1;\n}\n\n.page-title {\n  font-size: 1.375rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* User Menu Styles */\n.user-menu-container {\n  position: relative;\n}\n\n.user-menu-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: none;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.user-menu-trigger:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.user-avatar-small {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.user-name-header {\n  font-size: 15px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.chevron {\n  width: 16px;\n  height: 16px;\n  color: #6b7280;\n  transition: transform 0.2s ease;\n}\n\n.chevron.open {\n  transform: rotate(180deg);\n}\n\n.user-menu-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  min-width: 240px;\n  z-index: 1000;\n  animation: dropdownSlide 0.2s ease-out;\n}\n\n@keyframes dropdownSlide {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.user-menu-header {\n  padding: 16px;\n}\n\n.user-info-dropdown .user-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.user-info-dropdown .user-email {\n  font-size: 15px;\n  color: #64748b;\n  margin-bottom: 2px;\n}\n\n.user-info-dropdown .user-org {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.user-menu-divider {\n  height: 1px;\n  background: #e2e8f0;\n  margin: 0 8px;\n}\n\n.user-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-size: 15px;\n  color: #374151;\n  border-radius: 0 0 12px 12px;\n}\n\n.user-menu-item:hover {\n  background: #f8fafc;\n}\n\n.user-menu-item svg {\n  width: 16px;\n  height: 16px;\n  color: #6b7280;\n}\n\n/* Page Content Styles */\n.page-content {\n  flex: 1;\n  padding: 24px 32px 16px;\n  overflow-y: auto;\n  background: #f8fafc;\n  min-height: 0;\n}\n\n.app-footer {\n  flex-shrink: 0;\n  padding: 10px 32px 14px;\n  text-align: center;\n  font-size: 13px;\n  color: #94a3b8;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  letter-spacing: 0.02em;\n}\n\n.app-footer-brand {\n  font-weight: 700;\n  color: #64748b;\n  letter-spacing: 0.06em;\n}\n\n/* Sidebar Overlay for Mobile */\n.sidebar-overlay {\n  display: none;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100vh;\n    z-index: 200;\n    transform: translateX(-100%);\n  }\n\n  .sidebar:not(.collapsed) {\n    transform: translateX(0);\n  }\n\n  .sidebar-overlay {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 150;\n  }\n\n  .main-content {\n    margin-left: 0;\n  }\n\n  .main-header {\n    padding: 16px 20px;\n  }\n\n  .page-content {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 640px) {\n  .main-header {\n    padding: 12px 16px;\n  }\n\n  .page-title {\n    font-size: 20px;\n  }\n\n  .user-name-header {\n    display: none;\n  }\n\n  .page-content {\n    padding: 16px;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .layout-container {\n    background: #0f172a;\n  }\n\n  .main-header {\n    background: #1e293b;\n    border-bottom-color: #334155;\n  }\n\n  .page-title {\n    color: #f8fafc;\n  }\n\n  .user-menu-trigger {\n    border-color: #334155;\n    background: #1e293b;\n  }\n\n  .user-menu-trigger:hover {\n    background: #334155;\n    border-color: #475569;\n  }\n\n  .user-name-header {\n    color: #e2e8f0;\n  }\n\n  .user-menu-dropdown {\n    background: #1e293b;\n    border-color: #334155;\n  }\n\n  .user-info-dropdown .user-name {\n    color: #f8fafc;\n  }\n\n  .user-info-dropdown .user-email {\n    color: #94a3b8;\n  }\n\n  .user-menu-divider {\n    background: #334155;\n  }\n\n  .user-menu-item {\n    color: #e2e8f0;\n  }\n\n  .user-menu-item:hover {\n    background: #334155;\n  }\n\n  .page-content {\n    background: #0f172a;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
